import { Link } from '@tanstack/react-router'

import { Button } from '@/components/button'

interface Props {
    title: string
    errorMessage: string
}

export default function ResetError({ title, errorMessage }: Props) {
    return (
        <>
            <div className="flex flex-col space-y-2 text-center">
                <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
                <p>{errorMessage}</p>
            </div>
            <div className="flex items-center justify-between">
                <Button>
                    <Link to={'/forgot-password'}>Forgot password</Link>
                </Button>
                <Button>
                    <Link to={'/'}>Return to login</Link>
                </Button>
            </div>
        </>
    )
}
